import React, { FC } from "react";

type CheckableListItemProps = {
  id: string;
  title: string;
  checked?: boolean;
  disabled?: boolean;
  handleChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

const CheckableListItem: FC<CheckableListItemProps> = ({
  id,
  title,
  checked = false,
  disabled = false,
  handleChange,
}) => {
  return (
    <label
      htmlFor={`CheckableListItem_${id}`}
      className={`flex items-center gap-4 select-none rounded-lg border border-gray-200 px-4 py-2 transition ${disabled ? "cursor-default" : "hover:bg-gray-50 cursor-pointer"}`}
    >
      <div className="flex items-center">
        &#8203;
        <input
          type="checkbox"
          className={`size-4 rounded border-gray-300${disabled ? " cursor-not-allowed grayscale opacity-25" : ""}`}
          id={`CheckableListItem_${id}`}
          checked={checked}
          onChange={handleChange}
          disabled={disabled}
        />
      </div>

      <strong className="text-sm font-normal text-gray-900">{title}</strong>
    </label>
  );
};
export default CheckableListItem;
